export var ProfileEmailStatus;
(function (ProfileEmailStatus) {
    ProfileEmailStatus["VERIFIED"] = "verified";
    ProfileEmailStatus["PENDING"] = "verification_pending";
})(ProfileEmailStatus || (ProfileEmailStatus = {}));
export var ProfilePhoneStatus;
(function (ProfilePhoneStatus) {
    ProfilePhoneStatus["VERIFIED"] = "verified";
    ProfilePhoneStatus["PENDING"] = "verification_pending";
})(ProfilePhoneStatus || (ProfilePhoneStatus = {}));
export var AddressVerificationMethod;
(function (AddressVerificationMethod) {
    AddressVerificationMethod["PHONE"] = "phone";
    AddressVerificationMethod["EMAIL"] = "email";
})(AddressVerificationMethod || (AddressVerificationMethod = {}));
//# sourceMappingURL=address.js.map